import { Modal, Typography } from '@scale/scaleui';
import { ChatShareBox } from './ChatShareBox';
import { Dispatch, FC, SetStateAction } from 'react';

type ChatShareModalProps = {
  isModalOpen: boolean;
  slug: string;
  setModalOpen: Dispatch<SetStateAction<boolean>>;
};

export const ChatShareModal: FC<ChatShareModalProps> = ({ isModalOpen, setModalOpen, slug }) => (
  <Modal open={isModalOpen && !!slug} onClose={() => setModalOpen(false)}>
    <div className="mb-2">
      <Typography.Subtitle2>Share Chat</Typography.Subtitle2>
    </div>
    <ChatShareBox slug={slug} />
  </Modal>
);
